import React from 'react';
import DefaultWrapper from './DefaultWrapper';
import AdditionalWrapper from './AdditionalWrapper';
import Sources from '../Sources';

const Wrapper = ({ data, defaultType, content, spyNavData }) => {
  // TODO: пофиксить деструктуризацию
  const date = data?.date;
  const uri = data?.uri;
  const title = data?.title;

  const sources = data?.GuideArticleText
    ? data.GuideArticleText.guideArticleTextSources
    : data?.GuideArticleCard.articlePostSources;

  return (
    <section
      className={`${
        defaultType ? 'bg-transparent' : 'bg-merino'
      } pb-14 sm:pb-20`}
    >
      {/* TODO: temp */}
      <div className="pt-28 sm:pt-36 lg:pt-44"></div>

      <div className="fluid-container">
        {defaultType ? (
          <DefaultWrapper
            data={data}
            content={content}
            spyNavData={spyNavData}
          />
        ) : (
          <AdditionalWrapper
            data={data}
            content={content}
            spyNavData={spyNavData}
          />
        )}
      </div>

      <Sources sources={sources} publicDate={date} uri={uri} title={title} />
    </section>
  );
};

export default Wrapper;
